import Block from '../blots/block.js';


class Blockquote extends Block {}
Blockquote.blotName = 'blockquote';
Blockquote.tagName = 'blockquote';


export default Blockquote;



// WEBPACK FOOTER //
// ./formats/blockquote.js